import type { CustomerProfileDetailsResponseDTO } from '@/types/dto/agent';

type OfficialResidenceParts = {
  [K in keyof Pick<
    CustomerProfileDetailsResponseDTO,
    'streetAddress' | 'city' | 'county' | 'zipCode'
  >]?: string | null;
};

export function formatOfficialResidence(parts: OfficialResidenceParts): string {
  return [parts.streetAddress, parts.city, parts.county, parts.zipCode]
    .map((value) => value?.trim())
    .filter((value): value is string => Boolean(value))
    .join(', ');
}
